import { AfterViewInit, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { ContentChildren } from "@angular/core";
import { QueryList } from "@angular/core";
import { Directive } from "@angular/core";
import { Component } from "@angular/core";
import dxButton from "devextreme/ui/button";
import dxDropDownBox from "devextreme/ui/drop_down_box";
import dxDropDownButton from "devextreme/ui/drop_down_button";
import {LoginService} from "../../Services/login.service";
import {Router} from "@angular/router";
import {DxButtonComponent} from "devextreme-angular";




@Directive({
    selector: 'np-help-option',
    standalone: false
})
export class NpHelpOption {
  @Input() public icon: string;
  @Input() public text: string;
  @Input() public link: string;
  @Input() public route: string;
  @Input() public type: "contactsupport" | "tbd";

}

@Component({
  selector: "np-help-button",
  templateUrl: "NpHelpButton.component.html",
  styleUrls: ['NpHelpButton.css'],
  standalone: false
})
export class NpHelpButtonComponent{
  options: any[] = [];
  icon: string = "help";
  buttons: QueryList<NpHelpOption>;
  @ViewChild('helpBtn', { static: false }) helpBtn: DxButtonComponent;
  helpInfoVisible: boolean = false;
  constructor(public loginService: LoginService, public router: Router) {
    this.openHelpLink = this.openHelpLink.bind(this);
  }

  openHelpLink(e: any) {
    const item = e.itemData;

    if (!item) {
      return;
    }

    if (item.type == "contactsupport")
    {
      let email = this.loginService.currentUser.email;
      let lastName = this.loginService.currentUser.lastName;
      let firstName = this.loginService.currentUser.firstName;
      let link = `https://knowledge.nextpim.de/kb-tickets/new?email=${email}&lastname=${lastName}&firstname=${firstName}`;
      window.open(link, '_blank');
      return;
    }

    if (item.link != undefined) {
      window.open(item.link, "_blank")?.focus();
    }

    if (item.route != undefined) {
      this.router.navigate([item.route])
    }


  }

  @ContentChildren(NpHelpOption, { descendants: true })
  public set contentButtons(buttons: QueryList<NpHelpOption>) {
    this.buttons = buttons;
    this.options.push(...this.buttons?.map(b => {
      return {icon: b.icon, text: b.text, link: b.link, route: b.route, type: b.type};
    }));

  }

  showExternalLinkImage(link: string): boolean {

    return link != undefined;
  }

  toggleHelpMenu(): void {
    this.helpInfoVisible = !this.helpInfoVisible
  }
}
